export default function Photo({src, className, onClick}){
  return (<section className={`photo ${className!==undefined?className:''}`} onClick={onClick!==undefined?onClick:()=>{}}>
    <img src={src} alt="Intro Abstraction" />
  </section>);
}